import { requestData } from '@/api/request';
import type { DashboardStats } from '@/api/types';

export async function getDashboardStats() {
  return requestData<DashboardStats>({
    url: 'dashboard/',
  });
}